export default __webpack_public_path__ + "static/media/17.358d2203.jpg";